import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const LightningBoltIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon viewBox="0 0 25 24" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.0901 2.05826C14.4882 2.20035 14.7539 2.57738 14.7539 3.00005V9.00005L20.7539 9.00005C21.1403 9.00005 21.4921 9.22265 21.6576 9.57182C21.8231 9.92099 21.7726 10.3342 21.5279 10.6333L12.5279 21.6333C12.2602 21.9604 11.8158 22.0839 11.4177 21.9418C11.0197 21.7998 10.7539 21.4227 10.7539 21.0001L10.7539 15.0001H4.75392C4.36753 15.0001 4.01571 14.7775 3.85025 14.4283C3.68478 14.0791 3.73528 13.6659 3.97996 13.3668L12.98 2.36682C13.2476 2.03969 13.692 1.91616 14.0901 2.05826ZM6.86416 13.0001H11.7539C12.0191 13.0001 12.2735 13.1054 12.461 13.2929C12.6486 13.4805 12.7539 13.7348 12.7539 14.0001V18.1986L18.6437 11.0001L13.7539 11.0001C13.2016 11.0001 12.7539 10.5523 12.7539 10.0001V5.80146L6.86416 13.0001Z"
            />
        </SvgIcon>
    );
};

export default LightningBoltIcon;
